import React, { ReactNode } from 'react'

import useToggle from 'src/hooks/useToggle'

import { ToggleIconBase } from './styles'

interface Props {
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  children: string
  onChange?: (value: boolean) => void
  initialValue?: boolean
  className?: string
}

const ToggleIcon = ({
  leftIcon,
  rightIcon,
  children,
  onChange = () => null,
  initialValue = false,
  className,
}: Props) => {
  const { value: toggled, toggle } = useToggle({ value: initialValue, onChange })

  return (
    <ToggleIconBase
      className={className}
      onClick={toggle}
      toggled={toggled}
      color={toggled ? 'grey8' : 'grey2'}
    >
      {leftIcon}
      {children}
      {rightIcon}
    </ToggleIconBase>
  )
}

export default ToggleIcon
